import React from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { useDispatch } from "react-redux";

import "./Auth.scss";
import { doSignIn } from "../../../modules/auth/stores/thunk";

const SignInForm = () => {
  const dispatch = useDispatch();

  const handleSubmit = (params) => {
    dispatch(doSignIn({ ...params }));
  };
  
  return (
    <div className={`SignInForm`}>
      <Form
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
      >
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo.svg`}
              alt="logo"
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Logga in på ditt konto</div>
        </div>
        <div className="FormContent">
          <Form.Item
            label="Användarnamn"
            name="email"
            rules={[
              { type: "email", message: "Invalid Email" },
              { required: true, message: "Required" },
            ]}
          >
            <Input
              size="large"
              placeholder="namn@företag.se"
            />
          </Form.Item>
          <Form.Item
            label="Lösenord"
            name="password"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password size="large" placeholder="Lösenord" />
          </Form.Item>
          <div className="ForgotPassword">
            <Link to="/forgot-password">Glömt Lösenord?</Link>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Logga in
          </Button>
        </div>
      </Form>
      <div className="Register">
        Har du inget konto? <Link to="/register">Registrera här</Link>
      </div>
    </div>
  );
};

export default SignInForm;
